import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconEmailOpen';
/** Renders an SVG icon. */
const SvgEmailOpen = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.926 3.498a2 2 0 0 1 2.148 0l10 6.364A2 2 0 0 1 28 11.549V23a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V11.55a2 2 0 0 1 .926-1.688zM6 22.436V23a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-.134a1 1 0 0 1-.207-.159l-6.5-6.5-.01-.01-2.254 1.352a2 2 0 0 1-2.058 0l-2.254-1.352-.037.036zm4.933-7.31L6 19.707v-7.54l4.933 2.96Zm-3.546-4.46L16 15.834l8.613-5.168L16 5.186zM26 12.166l-4.95 2.97 4.95 4.95z"
      />
    </svg>
  );
};
SvgEmailOpen.displayName = displayName;
export default SvgEmailOpen;
